import { render, staticRenderFns } from "./QrokantNavbar.vue?vue&type=template&id=83c546f8&"
import script from "./QrokantNavbar.vue?vue&type=script&lang=js&"
export * from "./QrokantNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports